import React, { PropTypes } from 'react';

export default class ThreadsFilter extends React.Component {
  static propTypes = {
    filter: PropTypes.string,
    filterUnread: PropTypes.bool,
    onUnreadChecked: PropTypes.func.isRequired,
    filterStared: PropTypes.bool,
    onStaredChecked: PropTypes.func.isRequired,
    onFilterChanged: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onFilterChange = this.onFilterChange.bind(this);
  }

  onFilterChange(evt) {
    const value = evt.target.value;
    this.props.onFilterChanged(value);
  }

  render() {
    const { filter, filterUnread, filterStared } = this.props;

    return (
      <div className="ui segment filters">
        <div className="ui grid">
          <div className="four wide column">
            <div className="ui checkbox">
              <input
                type="checkbox"
                checked={filterUnread}
                onChange={this.props.onUnreadChecked}
              />
              <label>Non lu</label>
            </div>
          </div>
          <div className="four wide column">
            <div className="ui checkbox">
              <input
                type="checkbox"
                checked={filterStared}
                onChange={this.props.onStaredChecked}
              />
              <label>Suivi</label>
            </div>
          </div>
          <div className="eight wide column">
            <div className="ui input">
              <input
                type="text"
                placeholder="Qui ?"
                value={filter}
                onChange={this.onFilterChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ThreadsFilter.js